import {
  CHANGE_USER_PASSWORD_FAIL,
  CHANGE_USER_PASSWORD_REQUEST,
  CHANGE_USER_PASSWORD_SUCCESS,
  CREATE_USER_FAIL,
  CREATE_USER_REQUEST,
  CREATE_USER_SUCCESS,
  FETCH_USER_AUTH_FAIL,
  FETCH_USER_AUTH_REQUEST,
  FETCH_USER_AUTH_SUCCESS,
  FETCH_USER_CV_FAIL,
  FETCH_USER_CV_REQUEST,
  FETCH_USER_CV_SUCCESS,
  FETCH_USER_FAIL,
  FETCH_USER_REQUEST,
  FETCH_USER_SUCCESS,
  PROFILE_USER_FAIL,
  PROFILE_USER_REQUEST,
  PROFILE_USER_SUCCESS,
  UPDATE_EMAIL_USER_FAIL,
  UPDATE_EMAIL_USER_REQUEST,
  UPDATE_EMAIL_USER_SUCCESS,
} from "../../ActionType/UserType/UserType";

export const getUsersReducer = (
  state = { loading: true, users: [], total: "", error: "" },
  action
) => {
  switch (action.type) {
    case FETCH_USER_REQUEST:
      return {
        ...state,
        loading: true,
      };
    case FETCH_USER_SUCCESS:
      return {
        loading: false,
        users: action.payload.data,
        total: action.payload.total,
        error: "",
      };
    case FETCH_USER_FAIL:
      return {
        loading: false,
        users: [],
        total: "",
        error: "",
      };
    default:
      return state;
  }
};

export const changeUserPasswordReducer = (
  state = { loading: false, password: [], error: "" },
  action
) => {
  switch (action.type) {
    case CHANGE_USER_PASSWORD_REQUEST:
      return {
        loading: true,
      };
    case CHANGE_USER_PASSWORD_SUCCESS:
      return {
        loading: false,
        users: action.payload,

        error: "",
      };
    case CHANGE_USER_PASSWORD_FAIL:
      return {
        loading: false,
        users: [],

        error: "",
      };
    default:
      return state;
  }
};

export const profileUserReducer = (
  state = { loading: false, profile: [], error: "" },
  action
) => {
  switch (action.type) {
    case PROFILE_USER_REQUEST:
      return {
        loading: true,
      };
    case PROFILE_USER_SUCCESS:
      return {
        loading: false,
        profile: action.payload,

        error: "",
      };
    case PROFILE_USER_FAIL:
      return {
        loading: false,
        profile: [],

        error: action.error,
      };
    default:
      return state;
  }
};

export const getUserCvReducer = (
  state = { loading: true, userCvs: [], error: "" },
  action
) => {
  switch (action.type) {
    case FETCH_USER_CV_REQUEST:
      return {
        loading: true,
      };
    case FETCH_USER_CV_SUCCESS:
      return {
        loading: false,
        userCvs: action.payload,

        error: "",
      };
    case FETCH_USER_CV_FAIL:
      return {
        loading: false,
        userCvs: [],

        error: action.error,
      };
    default:
      return state;
  }
};

export const updateUserEmaildReducer = (
  state = { loading: false, email: [], error: "" },
  action
) => {
  switch (action.type) {
    case UPDATE_EMAIL_USER_REQUEST:
      return {
        loading: true,
      };
    case UPDATE_EMAIL_USER_SUCCESS:
      return {
        loading: false,
        email: action.payload,

        error: "",
      };
    case UPDATE_EMAIL_USER_FAIL:
      return {
        loading: false,
        email: [],

        error: action.error,
      };
    default:
      return state;
  }
};

export const getUserAuthReducer = (
  state = { loading: true, userAuth: [], error: "" },
  action
) => {
  switch (action.type) {
    case FETCH_USER_AUTH_REQUEST:
      return {
        loading: true,
      };
    case FETCH_USER_AUTH_SUCCESS:
      return {
        loading: false,
        userAuth: action.payload,

        error: "",
      };
    case FETCH_USER_AUTH_FAIL:
      return {
        loading: false,
        userAuth: [],

        error: "",
      };
    default:
      return state;
  }
};

export const createUserReducer = (
  state = { loading: false, user: [], error: "" },
  action
) => {
  switch (action.type) {
    case CREATE_USER_REQUEST:
      return {
        loading: true,
      };
    case CREATE_USER_SUCCESS:
      return {
        loading: false,
        user: action.payload,

        error: "",
      };
    case CREATE_USER_FAIL:
      return {
        loading: false,
        userAuth: [],

        error: action.error,
      };
    default:
      return state;
  }
};
